import type { StandardOrder } from '@/types/ShopFront/CheckoutStandards'

const allShipmentsAssigned = (order?: StandardOrder) => order?.shipments?.every((shipment) => (
  !!shipment.selectedShippingOption
))

type UpdateWithDefinedOrder = { success: true, newOrder: StandardOrder }
type UpdateWithUndefinedOrder = { success: boolean, newOrder?: StandardOrder }
export const orderResponseIsNotReadyForPayment = (
  update: UpdateWithDefinedOrder | UpdateWithUndefinedOrder,
): update is UpdateWithDefinedOrder => (
  !update.success
  || !update.newOrder
  || !allShipmentsAssigned(update.newOrder)
)

export const assertUpdateWithDefinedOrder = (
  update: UpdateWithDefinedOrder | UpdateWithUndefinedOrder,
  errormessage: string,
): UpdateWithDefinedOrder => {
  if (
    orderResponseIsNotReadyForPayment(update)
  ) {
    throw new Error(errormessage)
  }
  return update as UpdateWithDefinedOrder
}
